import * as React from "react";
import type { SVGProps } from "react";
const SvgAttachment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.36 22.6a7.37 7.37 0 0 1-5.21-12.57l6.5-6.5a5.25 5.25 0 0 1 7.42 7.42l-6.5 6.5a3.2 3.2 0 0 1-4.42 0 3.14 3.14 0 0 1 0-4.42l6.5-6.5a1.004 1.004 0 1 1 1.42 1.42l-6.5 6.5a1.11 1.11 0 0 0 .79 1.902c.295 0 .579-.116.79-.322l6.5-6.5a3.24 3.24 0 0 0-4.58-4.58l-6.5 6.5a5.36 5.36 0 0 0 7.58 7.58l6.5-6.5a1.004 1.004 0 1 1 1.42 1.42l-6.5 6.5a7.3 7.3 0 0 1-5.21 2.15"
    />
  </svg>
);
export default SvgAttachment;
